/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Display_NameInputs */

const en_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium`)
};

const id_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penelusuran Premium`)
};

const ms_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carian Premium`)
};

const ca_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cercador Premium`)
};

const cs_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium vyhledávač`)
};

const da_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søgning Premium`)
};

const de_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium`)
};

const et_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otsi tasulist teenust`)
};

const es_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscador Premium`)
};

const fr_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche Premium`)
};

const hr_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium tražilica`)
};

const it_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca Premium`)
};

const lv_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium meklēšana`)
};

const lt_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Premium“ paieška`)
};

const hu_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave keresés – Prémium előfizetés`)
};

const nl_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium`)
};

const nb_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk Premium`)
};

const pl_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium`)
};

const pt_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisa Premium`)
};

const ro_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium`)
};

const sk_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyhľadávanie Premium`)
};

const sl_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium Iskanje`)
};

const fi_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haku Premium`)
};

const sv_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök Premium`)
};

const vi_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm Premium`)
};

const tr_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium Arama`)
};

const el_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αναζήτηση Premium`)
};

const bg_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене Premium`)
};

const ru_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск Премиум`)
};

const sr_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium претрага`)
};

const uk_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук у Premium`)
};

const ka_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium`)
};

const hi_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium`)
};

const th_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium`)
};

const ko_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검색 프리미엄`)
};

const zh_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索 Premium`)
};

const zh_tw_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋高級版`)
};

const ja_search_display_name = /** @type {(inputs: Search_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Premium`)
};

/**
* | output |
* | --- |
* | "Search Premium" |
*
* @param {Search_Display_NameInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const search_display_name = /** @type {((inputs?: Search_Display_NameInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Display_NameInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_display_name(inputs)
	if (locale === "ms") return ms_search_display_name(inputs)
	if (locale === "ca") return ca_search_display_name(inputs)
	if (locale === "cs") return cs_search_display_name(inputs)
	if (locale === "da") return da_search_display_name(inputs)
	if (locale === "de") return de_search_display_name(inputs)
	if (locale === "et") return et_search_display_name(inputs)
	if (locale === "es") return es_search_display_name(inputs)
	if (locale === "fr") return fr_search_display_name(inputs)
	if (locale === "hr") return hr_search_display_name(inputs)
	if (locale === "it") return it_search_display_name(inputs)
	if (locale === "lv") return lv_search_display_name(inputs)
	if (locale === "lt") return lt_search_display_name(inputs)
	if (locale === "hu") return hu_search_display_name(inputs)
	if (locale === "nl") return nl_search_display_name(inputs)
	if (locale === "nb") return nb_search_display_name(inputs)
	if (locale === "pl") return pl_search_display_name(inputs)
	if (locale === "pt") return pt_search_display_name(inputs)
	if (locale === "ro") return ro_search_display_name(inputs)
	if (locale === "sk") return sk_search_display_name(inputs)
	if (locale === "sl") return sl_search_display_name(inputs)
	if (locale === "fi") return fi_search_display_name(inputs)
	if (locale === "sv") return sv_search_display_name(inputs)
	if (locale === "vi") return vi_search_display_name(inputs)
	if (locale === "tr") return tr_search_display_name(inputs)
	if (locale === "el") return el_search_display_name(inputs)
	if (locale === "bg") return bg_search_display_name(inputs)
	if (locale === "ru") return ru_search_display_name(inputs)
	if (locale === "sr") return sr_search_display_name(inputs)
	if (locale === "uk") return uk_search_display_name(inputs)
	if (locale === "ka") return ka_search_display_name(inputs)
	if (locale === "hi") return hi_search_display_name(inputs)
	if (locale === "th") return th_search_display_name(inputs)
	if (locale === "ko") return ko_search_display_name(inputs)
	if (locale === "zh") return zh_search_display_name(inputs)
	if (locale === "zh-tw") return zh_tw_search_display_name(inputs)
	if (locale === "ja") return ja_search_display_name(inputs)
	return en_search_display_name(inputs)
});